export default "__VITE_ASSET__DTwe26qC__"